/* eslint-disable no-undef */
import { createStore, applyMiddleware, compose } from 'redux';

import rootReducer from '../reducers';
import thunk from 'redux-thunk';

export default function configureStore(preloadedState) {
    const initialState = {};

    const composeEnhancer =
        (window.config.APP_ENV === 'APP_ENV' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
        compose;

    const middleware = [thunk];

    const enhancer = composeEnhancer(applyMiddleware(...middleware));

    return createStore(rootReducer, initialState, enhancer);
}
